/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Selection_End_InvalidInputs */

const en_audio_description_export_selection_end_invalid = /** @type {(inputs: Audio_Description_Export_Selection_End_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selection End is greater than the number of Events. This may be caused by the application running in Trial mode, or another issue.`)
};

const fr_audio_description_export_selection_end_invalid = /** @type {(inputs: Audio_Description_Export_Selection_End_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La sélection de fin dépasse le nombre d'événements. Cela peut être dû au mode d'essai ou à un autre problème.`)
};

const de_audio_description_export_selection_end_invalid = /** @type {(inputs: Audio_Description_Export_Selection_End_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Anzahl der Ereignisse ist größer als die Anzahl der Auswahlenden. Dies kann daran liegen, dass die Anwendung im Testmodus ausgeführt wird oder an einem anderen Problem.`)
};

const it_audio_description_export_selection_end_invalid = /** @type {(inputs: Audio_Description_Export_Selection_End_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La fine della selezione è maggiore del numero di eventi. Ciò potrebbe essere causato dall'applicazione in esecuzione in modalità di prova o da un altro problema.`)
};

const ru_audio_description_export_selection_end_invalid = /** @type {(inputs: Audio_Description_Export_Selection_End_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Количество событий, завершающих выделение, превышает их число. Это может быть вызвано работой приложения в пробном режиме или другой проблемой.`)
};

const es_audio_description_export_selection_end_invalid = /** @type {(inputs: Audio_Description_Export_Selection_End_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El fin de la selección es mayor que el número de eventos. Esto puede deberse a que la aplicación se está ejecutando en modo de prueba o a otro problema.`)
};

const zh_cn2_audio_description_export_selection_end_invalid = /** @type {(inputs: Audio_Description_Export_Selection_End_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择结束位置大于事件数量。这可能是由于应用程序以试用模式运行或其他问题导致的。`)
};

const ja_audio_description_export_selection_end_invalid = /** @type {(inputs: Audio_Description_Export_Selection_End_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択範囲の終了値がイベント数を超えています。これは、アプリケーションが試用モードで実行されているか、その他の問題が原因である可能性があります。`)
};

const hi_audio_description_export_selection_end_invalid = /** @type {(inputs: Audio_Description_Export_Selection_End_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selection End की संख्या Events की संख्या से अधिक है। इसका कारण एप्लिकेशन का ट्रायल मोड में चलना या कोई अन्य समस्या हो सकती है।`)
};

const pt_pt2_audio_description_export_selection_end_invalid = /** @type {(inputs: Audio_Description_Export_Selection_End_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O número de seleções finais é maior que o número de eventos. Isso pode ser causado pela execução do aplicativo no modo de avaliação ou por outro problema.`)
};

/**
* | output |
* | --- |
* | "Selection End is greater than the number of Events. This may be caused by the application running in Trial mode, or another issue." |
*
* @param {Audio_Description_Export_Selection_End_InvalidInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_selection_end_invalid = /** @type {((inputs?: Audio_Description_Export_Selection_End_InvalidInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Selection_End_InvalidInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_selection_end_invalid(inputs)
	if (locale === "de") return de_audio_description_export_selection_end_invalid(inputs)
	if (locale === "it") return it_audio_description_export_selection_end_invalid(inputs)
	if (locale === "ru") return ru_audio_description_export_selection_end_invalid(inputs)
	if (locale === "es") return es_audio_description_export_selection_end_invalid(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_selection_end_invalid(inputs)
	if (locale === "ja") return ja_audio_description_export_selection_end_invalid(inputs)
	if (locale === "hi") return hi_audio_description_export_selection_end_invalid(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_selection_end_invalid(inputs)
	return en_audio_description_export_selection_end_invalid(inputs)
});